import { Account } from '@/domain/usecases'
import { QueryClient } from 'react-query'
import PathConstants from '../../path-contants'
import BaseLoader, { DeferFunction, LoaderResponse } from '../base-loader'

export default class OnboardingBaseLoader extends BaseLoader {
  constructor(
    readonly account: Account.Model,
    protected readonly queryClient: QueryClient
  ) {
    super(account, PathConstants.Routes.HOME.value)
  }

  private ableToContinue(accountProfile: Account.Model): boolean {
    return accountProfile.onboardingCompleted === false && Account.hasPassPlan(accountProfile)
  }

  async loader(): LoaderResponse {
    const accountProfile = this.getAccount()
    return this.ableToContinue(accountProfile) ? null : this.notAllowedLoader.bind(this)()
  }

  async defer(fn: DeferFunction) {
    const accountProfile = this.getAccount()
    if (this.ableToContinue(accountProfile)) {
      return this.deferExec(fn)
    } else {
      return this.notAllowedLoader.bind(this)()
    }
  }
}
